{
  "name": "disposuite",
  "version": "6.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl",
    "build:S3Dev": "ng build --configuration \"S3Dev\"",
    "build:S3Staging": "ng build --configuration \"S3Staging\"",
    "build:S3Prod": "ng build --configuration \"S3Prod\"",
    "output": "ng extract-i18n --output-path src/locale",
    "test": "jest --coverage --no-watch --runInBand",
    "lint": "ng lint"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm test"
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.22",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.22",
    "@angular/compiler": "^21.2.22",
    "@angular/core": "^21.2.22",
    "@angular/forms": "^21.2.22",
    "@angular/localize": "^21.2.22",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.22",
    "@angular/platform-browser-dynamic": "^21.2.22",
    "@angular/router": "^21.2.22",
    "@angular/service-worker": "^21.2.22",
    "@auth0/auth0-angular": "^2.2.3",
    "@auth0/auth0-spa-js": "^2.1.3",
    "@ng-select/ng-select": "^21.8.2",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@perfectmemory/ngx-contextmenu": "^21.0.1",
    "angular-shepherd": "^21.0.5",
    "bootstrap": "^4.5.3",
    "bootstrap4-toggle": "^3.6.1",
    "file-saver": "^2.0.5",
    "gleap": "^10.1.0",
    "jquery": "^3.5.1",
    "jszip": "^3.6.0",
    "ngx-cookie": "^6.0.1",
    "ngx-ui-switch": "^15.0.0",
    "popper.js": "^1.16.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.22",
    "@angular/cli": "^21.2.22",
    "@angular/compiler-cli": "^21.2.22",
    "@angular/language-service": "^21.2.22",
    "@eslint/js": "^10.0.1",
    "@types/file-saver": "^2.0.1",
    "@types/jest": "^30.0.0",
    "@types/jszip": "^3.4.1",
    "@types/node": "^22.20.1",
    "angular-eslint": "21.4.0",
    "eslint": "^10.3.0",
    "husky": "^4.3.6",
    "jest": "^30.5.0",
    "jest-environment-jsdom": "^30.5.0",
    "jest-preset-angular": "^17.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.59.2"
  }
}
